<div class="promo-sections-container">
  
  <div class="promo-grid" *ngIf="!hasMentor && !isLoadingMentor">
    <div class="left-promos">
      
      <!-- Direct Apply Banner -->
      <div class="promo-banner direct-apply-banner" *ngIf="directApplyCount === 0">
        <div class="banner-content">
          <div class="open-badge">
            <div class="star-circle"><i class="pi pi-star-fill" style="color:#CDD12A"></i></div> Direct Apply Open for 2026-27 intake
          </div>
          <h2>One form | Every University<br>Zero Chaos</h2>
          <p>Apply to <strong>800+ partner universities</strong> worldwide<br>with a single, streamlined application.</p>
          <button class="action-btn" (click)="openDirectApply()">Explore Direct Apply &rarr;</button>
        </div>
        <div class="banner-graphics">
          <img src="../../../assets/images/dashboard_direct-apply.svg" alt="Direct Apply" class="illustration" />
        </div>
      </div>

      <!-- Expert Guidance Banner -->
      <div class="promo-banner expert-guidance-banner" [style.height]="directApplyCount > 0 ? '100%' : 'auto'" [class.full-mode]="directApplyCount > 0">
        <div class="banner-content">
          <h2>{{ directApplyCount > 0 ? 'Seek Expert Guidance !' : 'Expert Guidance, Whenever You Need It' }}</h2>
          <p>From university shortlisting to offer acceptance, get<br>one-on-one support from experienced mentors who<br>understand your journey.</p>
          <button class="action-btn yellow" (click)="openMentorConnect()">Book a session &rarr;</button>
        </div>
        <div class="banner-graphics">
          <img src="../../../assets/images/dashboard_expert-session.svg" alt="Mentors" class="illustration mentor-img" />
        </div>
      </div>

    </div>

    <div class="right-promos">
      <!-- Scholarships Card -->
      <!-- TODO: No existing API for scholarship matched data, using static text -->
      <div class="promo-banner scholarship-card">
        <div class="banner-graphics">
          <img src="../../../assets/images/Scholarship-dashboard.png" alt="Scholarships" class="illustration full-width" />
          <img src="../../../assets/images/Scholarship-circle-dashboard.png" alt="" class="circle-overlay" />
        </div>
        <div class="banner-content">
          <h2>Unlock Scholarship<br>Opportunities</h2>
          <p>We've matched scholarships based on your<br>academic profile. Explore funding options and<br>maximize your chances of studying abroad.</p>
          <!-- // TODO: replace link when scholarship route is available -->
          <button class="action-btn navy" (click)="goToScholarships()">View Scholarships &rarr;</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Full-Width Scholarship Banner for Mentees -->
  <div class="promo-banner mentor-scholarship-banner" *ngIf="hasMentor && !isLoadingMentor">
    <div class="banner-content">
      <h2>Unlock Scholarship Opportunities</h2>
      <p>We've matched scholarships based on your academic profile. Explore funding options and maximize your chances of studying abroad.</p>
      <!-- // TODO: replace link when scholarship route is available -->
      <button class="action-btn white-btn" (click)="goToScholarships()">View Scholarships &rarr;</button>
    </div>
    <div class="banner-graphics">
      <img src="../../../assets/images/dashboard_scholarship.svg" alt="Scholarships" class="illustration full-width" />
    </div>
  </div>

  <!-- Events Carousel -->
  <!-- // TODO: No existing API for events, using static mock data -->
  <div class="events-section">
    <div class="events-header">
      <h2>Upcoming events, Webinars & videos</h2>
    </div>
    
    <div class="events-carousel" *ngIf="!isLoadingVideos" #carouselContainer>
      <div class="event-card video-card" *ngFor="let video of videos">
        <div class="video-thumbnail" 
             [style.background-image]="'url(' + (video.thumbnailUrl || '') + ')'"
             (click)="openVideoUrl(video.videoId)">
          <div class="event-pill video">Videos</div>
          <div class="play-btn"><i class="pi pi-play"></i></div>
        </div>
        
        <h3 (click)="openVideoUrl(video.videoId)">{{ video.title }}</h3>
        
        <button class="watch-btn" (click)="openVideoUrl(video.videoId)">Watch Video</button>
      </div>

      <!-- Loading skeleton for infinite scroll -->
      <div class="event-card video-card" *ngIf="isLoadingMoreVideos">
        <div class="video-thumbnail loading-skeleton"></div>
        <div class="title-skeleton loading-skeleton"></div>
        <div class="btn-skeleton loading-skeleton"></div>
      </div>

      <!-- Scroll anchor -->
      <div #videoScrollAnchor style="width: 10px; flex-shrink: 0;"></div>
    </div>
  </div>

</div>
